<template>
    <b-modal ref="registrationModal" size="lg" :title=title>
      <!-- SCHOOL -->
      <div v-if="step === 0">
        <find-school :country="competition.country" v-on:selected="selectedSchool => this.school = selectedSchool"></find-school>
      </div>

      <!-- CLASSES -->
      <div v-if="step === 1">
        <class-list v-if="competition.loaded()"
          :competition=competition
          :classes=registeredClasses
          v-on:update=setRegisteredClasses>
        </class-list>
      </div>

      <!-- CONFIRMATION -->
      <div v-if="step === 2">
        <h5>{{ this.school.name }}</h5>
        <h6>Anmeldungen:</h6>
        <ul>
          <li v-for="group in registeredClasses.models" :key="group.ageGroup">
            {{ group.ageGroup }}. Klasse: {{ group.count }} ({{ group.type === 'paper' ? 'Papier' : 'Online' }})
          </li>
        </ul>
      </div>

      <template slot="modal-footer">
        <b-btn :disabled=continueButtonDisabled class="mt-3" variant="primary" block @click="next">
          {{ continueButtonLabel }}
        </b-btn>

        <b-btn class="mt-3" variant="secondary" block @click="back">
          {{ backButtonLabel }}
        </b-btn>
      </template>
    </b-modal>
</template>

<script>
import FindSchool from '@/components/schools/FindSchool'
import ClassList from '@/components/competitions/registration/ClassList'
import {RegisteredClass, RegisteredClassList} from '@/models'

export default {
  name: 'RegistrationModal',
  props: ['competition'],
  components: {
    FindSchool,
    ClassList
  },

  data: function () {
    return {
      step: 0,
      registrationId: null,
      school: null,
      registeredClasses: new RegisteredClassList()
    }
  },

  computed: {
    title: function () {
      if (this.registrationId) {
        return 'Anmeldung bearbeiten'
      }

      return 'Schule anmelden'
    },

    continueButtonDisabled: function () {
      if (this.step === 0 && !this.school) {
        return true
      }

      return this.step === 1 && this.registeredClasses.length < 1
    },

    continueButtonLabel: function () {
      return this.step === 2 ? 'Speichern' : 'Weiter'
    },

    backButtonLabel: function () {
      if (this.step > 1 || (this.registrationId === null && this.step > 0)) {
        return 'Zurück'
      }

      return 'Abbrechen'
    }
  },

  filters: {
    nl2br: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.split('\n').join('<br/>')
    }
  },

  methods: {
    add: function () {
      this.step = 0
      this.$refs.registrationModal.show()
    },

    next: function () {
      if (this.step < 2) {
        this.step++
        return
      }

      this.send()
    },

    back: function () {
      if (this.step > 1 || (this.registrationId === null && this.step > 0)) {
        this.step--
        return
      }

      this.$refs.registrationModal.hide()
      this.reset()
    },

    reset: function () {
      this.step = 0
      this.selectedSchool = null
      this.registrationId = null
      this.registeredClasses = new RegisteredClassList()
    },

    setRegisteredClasses: function (registeredClasses) {
      this.registeredClasses = registeredClasses
    },

    edit: function (registrationID, school) {
      this.step = 1
      this.registrationId = registrationID
      this.school = school
      this.registeredClasses.clear()

      this.axios.get('/registrations/' + registrationID)
        .catch(err => this.$eventHub.$emit('error', err))
        .then((rsp) => {
          rsp.data.payload.registeredClasses.forEach(c => {
            this.registeredClasses.add(new RegisteredClass(c))
            this.registeredClasses.sort('ageGroup')
          })
        })

      this.$refs.registrationModal.show()
    },

    send: function () {
      const requestConfig = {
        method: this.registrationId ? 'PATCH' : 'POST',
        url: '/registrations' + (this.registrationId ? '/' + this.registrationId : ''),
        data: {
          competitionId: this.competition.id,
          schoolId: this.school.id,
          registeredClasses: this.registeredClasses
        }
      }

      this.axios.request(requestConfig)
        .catch(err => this.$eventHub.$emit('error', err))
        .then(rsp => this.$emit('update', rsp.data))
        .finally(() => this.$refs.registrationModal.hide())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/registration/RegistrationModal.vue